import httpUtil from "../assets/script/utils/http";
import { Pageable } from "../assets/script/model/";

class ListGuid {
  constructor() {
    this.RankingListGuid = "";
  }
}
const state = {
  Pageable: new Pageable(1, 20),
  listGuid: new ListGuid()
};

const mutations = {};

const actions = {
  //热榜 参数pageIdex,pageSize (一下这两个参数默认值都是1，20)
  ASoaringWord(ctx, params) {
    return httpUtil.post("/ai/SoaringWords", params);
  },
  //热榜 参数pageIdex,pageSize (一下这两个参数默认值都是1，20)
  AHotWord(ctx, params) {
    return httpUtil.post("/ai/HotWord", params);
  },
  //微博 参数pageIdex,pageSize
  AWeiBoSo(ctx, params) {
    return httpUtil.post("/ai/WeiBoSo", params);
  },
  //百度热搜 参数pageIdex,pageSize
  ABaidu(ctx, params) {
    return httpUtil.post("/ai/Baidu", params);
  },
  //360实时 参数pageIdex,pageSize
  AHaoSou(ctx, params) {
    return httpUtil.post("/ai/HaoSou", params);
  },
  //热文推荐 参数pageIdex,pageSize和RankingListGuid
  //2A61B1E1-F632-E811-B201-D4AE52D0F72C ： 5ce_bd榜单_5ce_当前最热
  //2B61B1E1-F632-E811-B201-D4AE52D0F72C ： 5ce_bd榜单_5ce_7天最热
  //2C61B1E1-F632-E811-B201-D4AE52D0F72C ： 5ce_bd榜单_5ce_30天最热
  AMedia(ctx, params) {
    return httpUtil.post("/ai/Media", params);
  },
  //微信 参数pageIdex,pageSize
  AWeiXin(ctx, params) {
    return httpUtil.post("/ai/WeiXin", params);
  },
  //知乎 参数pageIdex,pageSize和RankingListGuid
  //BBC101AD-B422-E811-B201-D4AE52D0F72C ： 5ce_bd榜单_知乎_今日最热
  //E24511B3-B422-E811-B201-D4AE52D0F72C ： 5ce_bd榜单_知乎_本月最热
  AZhuHu(ctx, params) {
    return httpUtil.post("/ai/zhiHu", params);
  },
  //百度贴吧 参数pageIdex,pageSize
  ABaiduBar(ctx, params) {
    return httpUtil.post("/ai/BaiduBar", params);
  },
  //豆瓣 参数pageIdex,pageSize
  ADouBan(ctx, params) {
    return httpUtil.post("/ai/DouBan", params);
  },
  AHotRankList(ctx, params) {
    return httpUtil.post("/ai/hotranking", params);
  },
  AHotRankNewList(ctx, params) {
    return httpUtil.post("/ai/new", params);
  },
  AHotRankHistoryList(ctx, params) {
    return httpUtil.post("/ai/history", params);
  },
  AHotRankDetail(ctx, params) {
    return httpUtil.post("/ai/detail", params);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
